
// 登录用户信息
export const USERINFO = 'USERINFO';
// 左侧导航切换
export const COLLAPSEDTOGGLE = 'COLLAPSEDTOGGLE';
// 设置面包屑导航数据
export const SETBREADCRUMB = 'SETBREADCRUMB';
// 面包屑导航右侧reload的标志
export const RELOAD = 'RELOAD';
// 浏览器信息（宽度、高度等）
export const WINDOWINFO = 'WINDOWINFO';
// 切换主题
export const CURRENTTHEME = 'CURRENTTHEME';
// 用户列表
export const USERLIST = 'USERLIST'

export const LIBRARYID = 'LIBRARYID'
//菜单
export const MENU = 'MENU'
//年份
export const YAER = 'YAER'
//IDS
export const IDS = 'IDS'

export const FRESHMENU = 'FRESHMENU'

export const LIBRARYNAME = 'LIBRARYNAME'

export const CHOOSELIBRARY = 'CHOOSELIBRARY'

export const SCOREINFO = 'SCOREINFO'

export const LIBRARYARR = 'LIBRARYARR'
